export default "__VITE_ASSET__uuJ$zPRN__"